import React, { useState, useEffect, useRef } from 'react';
import Header from './Header/Header'
import HeroSection from './HeroSection/HeroSection'
import WhatAreLumiAds from './WhatAreLumiAds/WhatAreLumiAds';
import WhyLumiAds from './WhyLumiAds/WhyLumiAds';
import TryCreative from './TryCreative/TryCreative';
import Footer from './Footer/Footer';
import './styles/Main.scss'

const AdsPage = () => {
    document.title = "Lumi Ads";
    const [currentSection, setCurrentSection] = useState('');

    const sectionRefs = {
        heroSection: useRef(null),
        whatAreLumiAds: useRef(null),
        whyLumiAds: useRef(null),
        tryCreative: useRef(null),
        footer: useRef(null),
    };

    useEffect(() => {
        const observerOptions = {
            root: null, // viewport
            rootMargin: '0px',
            threshold: 0.15,
        };

        const observerCallback = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    setCurrentSection(entry.target.id); // Set current section's id
                } else {
                    entry.target.classList.remove('visible');
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        // Observe each section
        Object.values(sectionRefs).forEach(ref => {
            if (ref.current) {
                observer.observe(ref.current);
            }
        });

        return () => {
            // Clean up observer on unmount
            observer.disconnect();
        };
    }, []);
    return (
        <div className="ads_page">
            <Header currentSection={currentSection} />
            <div id="home" ref={sectionRefs.heroSection}>
                <HeroSection />
            </div>
            <div id="whatAreLumiAds" ref={sectionRefs.whatAreLumiAds}>
                <WhatAreLumiAds />
            </div>
            <div id="features" ref={sectionRefs.whyLumiAds}>
                <WhyLumiAds />
            </div>
            <div id="try-your-creative" ref={sectionRefs.tryCreative}>
                <TryCreative />
            </div>
            <div id="footer" ref={sectionRefs.footer}>
                <Footer />
            </div>
        </div>
    )
}

export default AdsPage